import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';
import BMText from '../Text/BMText';
import { BMPrimitives } from '../../theme';
function HolidayBadge(props) {
    const { day, holiday } = props;
    return (<View style={styles.container}>
      <BMText variant={'uiSmallEm'} ink={'BMUiCalendarInkHoliday'} style={styles.day}>
        {day}
      </BMText>
      <BMText variant={'uiSmall'} ink={'BMStyleTextInkSecondary'}>
        {holiday}
      </BMText>
    </View>);
}
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    day: {
        marginRight: BMPrimitives.BMSize.xs,
    },
});
export default memo(HolidayBadge);
